import { useEffect, useState, useContext } from "react";
import { getWallet } from "../Utils/utils";
import { WalletContext } from "../contexts/Wallet-context";

const WalletPage = () => {
    const [wallet, setWallet] = useState({});
    let [amount, setAmount] = useState(wallet.amount || 0);
    let stWallet = useContext(WalletContext);

    useEffect(() => {
        // 0xa3434719e10ecbfdb4ba31332775fa0b32a8a3bc
        const w = getWallet();
        setWallet(w);
        setAmount(w.amount || 0);
        amount = w.amount;
        console.log(w);    
    }, [stWallet, amount])

    return (
        <div className="wallet-page">
            <ul className="padding-0">
                <li className="flex-box wallet-li">
                    <h3>Wallet</h3>
                    <span className="wallet-b">Balance <span>{amount} $SGT</span></span>
                </li>
            </ul>
        </div>
    );
}   

export default WalletPage;